import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

//import { IListItem, IListItemManager } from '../../interfaces/ilist-item.interface';
import { Folder } from '../site-content/folder.model';
import { FormInstance } from '../site-content/form-instance.model';
import { IListViewLiaison } from '../../components/list-view/ilist-view-liaison.interface';
import { ListViewComponent } from '../../components/list-view/list-view.component';
import { StructureComponent, StructureListViewData } from '../../../views/site/structure/structure.component';
import { ItemTypeEnum } from '../../enums/item-type.enum';
import { AccessibilityHelper } from '../../../shared/accessibility.helper';
import { TreeConstants } from '../../../shared/components/folder-tree/folder-tree.component';
import {
    FOLDER,
    FORM_INSTANCE,
    VIEW,
    SAVE_FORM_INSTANCE,
    RESET_FORM_INSTANCE,
    PUBLISH,
    PRINT_FORM_INSTANCE,
    BULK_WORKFLOW,
    HISTORY,
    SUBSCRIBE,
    IMPORT_FORM_INSTANCE_DATA,
    IMPORT_FORM_INSTANCE_FILES,
    EXPORT_FORM_INSTANCE_FILES,
    EXPORT_TO_EXCEL,
    FORM,
    UP_ONE_LEVEL,
    TREE,
    INFO,
    ROLES,
    FAVORITE,
    TRUE,
    FALSE,
    FoldersFormInstancesFavoritesButtonConfig,
    ViewAndManageRolesButtonConfig
} from '../../../views/site/structure/structure.extras';
import { IButtonConfig, IButtonConfigClickHandler } from '../../../shared/components/list-view/list-view-button-config.model';
import { ImportStructureInstancesDialog } from '../../../shared/dialogs/import-structure/import-structure.dialog';
import { ImportFormInstancesDialog } from '../../../shared/dialogs/import-form-data/import-form-instances.dialog';
import { ListViewEnum, ListViewHelper } from '../../../shared/components/list-view/list-view.helper';
import { ListItemMoveData } from '../../../shared/components/list-view/list-view-item-move-action';
import { UtilityHelper } from '../../../shared/utility.helper';
import { TrashConfig, TrashDeleteEvent } from '../../../shared/components/list-view/list-view-trash-config.model';
import { ListItemDragActionData } from '../../../shared/components/list-view/list-view-drag-action.model';
import { IListItem, IListItemManager } from '../../../shared/interfaces/ilist-item.interface';

export class StructureComponentListViewLiaison implements IListViewLiaison {
    // Properties.
    //public selectedFolder: Folder = null; // Need to make the structure component use this property instead of its own.
    //public selectedFormInstance: FormInstance = null; // Need to make the structure component use this property instead of its own.

    // Properties/constructor.
    // Inputs for the list view component.
    public constructor(
        private structureComponent: StructureComponent,
        public defaultSort: string, // [defaultSortColumn]
        public listType: string) // Input property [listType]
    {
    }

    // Implement interface IListViewLiaison.
    public listViewInitializing(listViewComponent: ListViewComponent): void {
        // Set relevant inputs.
        //listViewComponent.list = this.structureComponent.ListItems;
        //listViewComponent.list = this.structureListViewData.listItems;
        //listViewComponent.list = this.getListItems();
        listViewComponent.defaultSortColumn = this.defaultSort;
        listViewComponent.selectedId = this.getSelectedId();
        //listViewComponent.title = this.title;
        listViewComponent.listType = this.listType;
        //listViewComponent.heading = this.structureComponent.CurrentFolder !== this.structureComponent.RootFolder ? this.structureComponent.CurrentFolder.name : null;
        //listViewComponent.buttonConfig = this.structureComponent.ButtonConfig; // comments out by pharvey for VNEXT-704
        listViewComponent.columnsConfig = ['select', 'name', 'modifiedDate', 'modifiedBy', 'property(Template)', 'property(Status)'];
        listViewComponent.showTreeButton = true;
        listViewComponent.typeSortOrderConfig = [ItemTypeEnum.FOLDER, ItemTypeEnum.FORM_INSTANCE];
        listViewComponent.currentFolder = this.structureComponent.CurrentFolder;
        listViewComponent.enableInfiniteScrolling = true;
        listViewComponent.listResetAt = this.structureComponent.StructureResetAt;
        listViewComponent.listItemsAreDraggable = this.structureComponent.ColumnSortingIsOff;
        //listViewComponent.totalListCount = this.structureComponent.TotalListCount;
        listViewComponent.configureStructureFields = this.structureComponent.ConfiguredStructureFields;

        // Subscript to relevant outputs.
        listViewComponent.editClick.subscribe(event => {
            //this.structureComponent.displayEntity(event);
            this.displayEntity(event);
        });
        listViewComponent.buttonClick.subscribe(event => {
            this.doOnButtonClick(event);
        });

        listViewComponent.itemActionClick.subscribe(event => {
            this.doOnItemAction(event);
        });

        listViewComponent.itemDeleted.subscribe(event => {
            this.doOnItemDeleted(event);
        });

        // Note:  unable to subscribe to the 'contextmenu' output.
        //listViewComponent.contextmenu.subscribe(event => {
        //});
        /*
        listViewComponent.itemContextMenu.subscribe(event => {
            this.onListViewContextMenu(event);
        });
        */

        listViewComponent.loadMore.subscribe(event => {
            this.handleLoadMore(event);
        });

        listViewComponent.sortChange.subscribe(event => {
            this.handleSortChange(event);
        });

        listViewComponent.filterTermChange.subscribe(event => {
            this.handleFilterTermChange(event);
        });

        listViewComponent.itemMoved.subscribe(event => {
            this.doOnItemMoved(event);
        });

        listViewComponent.dragged.subscribe(event => {
            this.doOnDragActionToStructure(event);
        });

        listViewComponent.filesDropped.subscribe(event => {
            this.structureComponent.onFileDropped(event);
        });

        listViewComponent.selectionsSet.subscribe(event => {
            this.structureComponent.setSelections(event);
        });
    }

    /*
    public getListItems(): IListItem[] {
        return this.structureListViewData.listItems;
    }
    */

    public getSelectedId(): number {
        if (this.structureComponent.SelectedFolder != null) {
            return this.structureComponent.SelectedFolder.id;
        } else if (this.structureComponent.SelectedFormInstance != null) {
            return this.structureComponent.SelectedFormInstance.id;
        } else if (this.structureComponent.RolesTargetFolder) {
            return this.structureComponent.RolesTargetFolder.id;
        }
        else {
            return null;
        }
    }

    public displayEntity(eventData: any): void {
        this.structureComponent.CurrentFolderService.nullifyCurrentFolder();
        let eventType = AccessibilityHelper.deduceEventType(eventData.originalEvent);
        if (!eventData.item) {
            // the last node in the tree was deleted, so just reload everything
            let url: string = `/site/${this.structureComponent.site.id}/structure`;
            this.structureComponent.Router.navigateByUrl(url, { state: { originalEventType: eventType } });
        }
        else if ((eventData.item.getType() == TreeConstants.FOLDER_NODE) || (eventData.item.getType() == FOLDER)) {
            let url: string = `/site/${this.structureComponent.site.id}/structure/folder/${eventData.item.id}`;
            this.structureComponent.Router.navigateByUrl(url, { state: { originalEventType: eventType } });
        } else if (eventData.item.getType() == TreeConstants.FORM_NODE || eventData.item.getType() == FORM_INSTANCE) {
            let url1: string = `/site/${this.structureComponent.site.id}/structure/folder/${this.structureComponent.CurrentFolder.id}/form/${eventData.item.id}`;
            this.structureComponent.Router.navigateByUrl(
                url1,
                { state: { originalEventType: eventType } }).then(x => {
                    this.structureComponent.CommunicationService.emitChangeToSkipNavLink(url1);
                });
        }
    }

    public doOnButtonClick(eventData: any): void {
        let useButtonClickHandler: boolean = false;

        if (eventData.button == HISTORY) {
            this.structureComponent.ShowHistory = true;
        } else if (eventData.button == SUBSCRIBE) {
            useButtonClickHandler = true;
        } else if (eventData.button == PUBLISH) {
            useButtonClickHandler = true;
        } else if (eventData.button == FOLDER) {
            useButtonClickHandler = true;
        } else if (eventData.button == FORM) {
            useButtonClickHandler = true;
        } else if (eventData.button == UP_ONE_LEVEL) {
            useButtonClickHandler = true;
        } else if (eventData.button == TREE) {
            useButtonClickHandler = true;
        } else if (eventData.button == IMPORT_FORM_INSTANCE_DATA) {
            this.doOnImportStructureInstances();
        } else if (eventData.button == IMPORT_FORM_INSTANCE_FILES) {
            this.doOnImportDataFiles();
        } else if (eventData.button == EXPORT_FORM_INSTANCE_FILES) {
            useButtonClickHandler = true;
        } else if (eventData.button == EXPORT_TO_EXCEL) {
            useButtonClickHandler = true;
        } else if (eventData.button == SAVE_FORM_INSTANCE) {
            useButtonClickHandler = true;
        } else if (eventData.button == RESET_FORM_INSTANCE) {
            useButtonClickHandler = true;
        } else if (eventData.button == PRINT_FORM_INSTANCE) {
            useButtonClickHandler = true;
        } else if (eventData.button = BULK_WORKFLOW) {
            useButtonClickHandler = true
        } else {
            console.log("StructureComponent#doOnButtonClick() ==> Unknown Operation!");
        }

        // Use the button click handler?
        if (useButtonClickHandler)
            StructureComponentListViewLiaison.callButtonClickHandler(eventData.buttonConfig, eventData.button, eventData);
    }

    public doOnImportStructureInstances(): void {
        // Process an import structure instances dialogue
        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = this.structureComponent.CurrentFolder;

        const dialogRef = this.structureComponent.Dialog.open(ImportStructureInstancesDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(importedFormId => {
            // Note:  the import is performed in the dialog component class.
            if ((importedFormId != null) && (importedFormId > 0)) {
                this.structureComponent.reloadStructure();
            }
        });
    }

    public doOnImportDataFiles(): void {
        // Process an import structure instances dialogue
        //
        // Note:  presently this dialogue only exports
        //        form instances.
        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = this.structureComponent.CurrentFolder;

        const dialogRef = this.structureComponent.Dialog.open(ImportFormInstancesDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(importedFormId => {
            // Note:  the export is performed in the dialog component class.
            if ((importedFormId != null) && (importedFormId > 0)) {
                this.structureComponent.reloadStructure();
            }
        });
    }

    // Helper methods.
    private static callButtonClickHandler(buttonConfig: IButtonConfig, buttonName: string, eventData: any, contextItem: any = null): void {
        let buttonConfigClickHandler: IButtonConfigClickHandler = (buttonConfig != null ? buttonConfig.buttonClickHandler : null);

        if (buttonConfig == null) {
            let errorMsg = `StructureComponent.doOnButtonClick():  there is not button config for button '${buttonName}'.`;
            throw errorMsg;
        } else if (buttonConfigClickHandler == null) {
            let errorMsg = `StructureComponent.doOnButtonClick():  there is not button click handler for button '${buttonName}'.`;
            throw errorMsg;
        }

        buttonConfigClickHandler.handlePreButtonClick(); // Note:  it is important to call this method before calling handleButtonClick().
        buttonConfigClickHandler.handleButtonClick(buttonConfig, eventData, contextItem);
    }

    private doOnItemAction(eventData: any): void {
        StructureComponentListViewLiaison.callButtonClickHandler(eventData.button, eventData.value, eventData, eventData.item);
    }

    public doOnItemDeleted(eventData: TrashDeleteEvent) {
        let retVal = new Promise((resolve, reject) => {
            if (eventData.items) {

                this.structureComponent.DeleteOnConfirmDialogService.deleteOnConfirmMultipleItems(this.structureComponent.Dialog, eventData.items, () => {

                    let promises: Promise<any>[] = [];

                    eventData.items.forEach(item => {
                        let itemType: string = item.getType();

                        if (itemType == Folder.TypeName) {

                            let folderPromise = this.structureComponent.deleteFolderServiceCall(item).then(response => {
                                if (response) {
                                    resolve(null);
                                }
                            });

                            promises.push(folderPromise);
                        }
                        else if (itemType == FormInstance.TypeName) {

                            let formInstancePromise = this.deleteFormInstanceServiceCall(item).then(response => {
                                if (response) {
                                    resolve(null);
                                }
                            });

                            promises.push(formInstancePromise);
                        }
                    });

                    Promise.all(promises).then((x) => {
                        this.structureComponent.reloadStructure();
                        AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
                        this.structureComponent.forceTreeRedraw();
                    });
                });
            }
        });
    }

    private deleteFolderServiceCall(folder: Folder): Promise<boolean> {
        let url: string = this.structureComponent.returnPath();

        return new Promise<boolean>((resolve) => {
            this.structureComponent.Router.navigateByUrl(url).then(x => {
                this.structureComponent.FolderService.delete(folder.id).then(x => {
                    resolve(true);
                });
            });
        });
    }

    private deleteFormInstanceServiceCall(formInstance: FormInstance): Promise<boolean> {
        let url: string = this.structureComponent.returnPath();

        return new Promise<boolean>((resolve) => {
            this.structureComponent.Router.navigateByUrl(url).then(x => {
                this.structureComponent.FormInstanceService.delete(formInstance.id).then(x => {
                    resolve(true);
                });
            });
        });
    }

    private onListViewContextMenu(event: any): void {
        //VNEXT-698: KLW - Restore the context menu functionality where the original issue was trying to use "event" as a PointerEvent when it's not 
        if (event.originalEvent) {
            let origEvent = event.originalEvent;

            origEvent.preventDefault();
            origEvent.stopPropagation();

            // Set the context menu position.
            let pageContextMenuPositionX = origEvent.clientX + 'px';
            let pageContextMenuPositionY = origEvent.clientY + 'px';
            if (this.structureComponent.listViewContextMenuComponent != null)
                this.structureComponent.listViewContextMenuComponent.openMenuForItemAt(this, pageContextMenuPositionX, pageContextMenuPositionY);
        }
    }

    private handleLoadMore($event, startAt = null, sortChange = false) {
        let list;
        if (startAt == null) {
            startAt = this.structureComponent.ListItems.length;
            list = Object.assign([], this.structureComponent.ListItems);
        } else {
            list = [];
        }

        this.structureComponent.FolderService.getWithPagination(this.structureComponent.CurrentFolder.id, true, startAt).then(folder => {
            this.updateListItems(folder, list, sortChange);
        });
    }

    // pharv ~ startOver added 3/20/2023 for VNEXT-605
    private updateListItems(folder: Folder, list: any, startOver = false) {
        this.structureComponent.TotalListCount = folder.totalChildFolderCount + folder.totalFormInstanceCount;
        folder.childFolders.forEach(f => {
            let folderAlreadyInList = this.structureComponent.ListItems.filter(listItem => {
                return listItem.getId() == f.id && listItem.getType() == FOLDER;
            }).length > 0;

            if (!folderAlreadyInList || startOver) {
                let folder = Object.assign(new Folder(), f);
                list.push(folder);
                this.structureComponent.CurrentFolder.childFolders.push(folder);
            }
        });
        folder.formInstances.forEach(fi => {
            let formInstanceAlreadyInList = this.structureComponent.ListItems.filter(listItem => {
                return listItem.getId() == fi.id && listItem.getType() == FORM_INSTANCE;
            }).length > 0;

            if (!formInstanceAlreadyInList || startOver) {
                list.push(Object.assign(new FormInstance(), fi));
            }
        });
        this.structureComponent.ListItems = list;
        this.structureComponent.structureReset();
    }

    public handleSortChange(event: any) {
        //console.log('Structure.handleSortChange()');
        this.handleLoadMore(event, 0, true);
    }

    private handleFilterTermChange(term: any) {
        this.structureComponent.FilterTerm = term;

        let list = [];

        this.structureComponent.FolderService.getWithPagination(this.structureComponent.CurrentFolder.id, true, 0, ListViewHelper.PAGE_SIZE, term).then(folder => {
            this.updateListItems(folder, list, true);
            if (!term) this.structureComponent.structureReset(); // if term is false that means user has blanked out the filter field meaning we just fetched first page full dataset afresh
        });
    }

    // pharvey 12/17/2021 - Moved the guts of moving List Items from BaseViewComponent to here since
    // it all relates to movement within structure and contains a lot of references
    // to Structure specific stuff.
    private doOnItemMoved(moveData: ListItemMoveData, movedViaTree: boolean = false) {
        if (moveData.NothingMoved) {
            return null;
        }

        let movedItems = moveData.MovedItems;
        let targetItem = moveData.TargetOfMove;

        let errorMsg = this.getErrorMessage(movedItems, targetItem);
        if (errorMsg) {
            alert(errorMsg);
            return;
        }

        // If target is a Folder and moved is a single Folder:                            PROMPT move or reposition
        // If target is a Folder and moved is not a single Folder:                        PROMPT move
        // If target is a FormInstance and moved is not a single FormInstance             DO NOTHING
        // If target is a FormInstance and moved is single FormInstance                   REPOSITION

        let oneItemMoved = movedItems.length == 1;
        let targetIsFolder = UtilityHelper.isTypeFolder(targetItem);
        let oneFolderMoved = oneItemMoved && UtilityHelper.isTypeFolder(movedItems[0]);
        let targetIsFormInstance = UtilityHelper.isTypeFormInstance(targetItem);
        let oneFormInstanceMoved = oneItemMoved && UtilityHelper.isTypeFormInstance(movedItems[0]);
        let showMoveOrRepositionPrompt = !movedViaTree && targetIsFolder && oneFolderMoved;
        let targetIsBreadcrumb = UtilityHelper.isTypeBreadcrumb(targetItem);
        let idsAndNewPositions: any = null;

        if (targetIsFormInstance && oneFormInstanceMoved) {
            if (this.cannotSortAlertTriggered()) return;

            let movedItem = movedItems[0];
            idsAndNewPositions = this.structureComponent.getNewPositionsForType(movedItem, targetItem, FormInstance.TypeName);
            this.structureComponent.moveItems(movedItems, targetItem, idsAndNewPositions);
        } else if (moveData.Reorder) {
            if (this.cannotSortAlertTriggered()) return;

            let movedItem = movedItems[0];
            idsAndNewPositions = this.structureComponent.getNewPositionsForType(movedItem, targetItem, Folder.TypeName);
            this.structureComponent.moveItems(movedItems, targetItem, idsAndNewPositions);
        } else {
            this.structureComponent.confirmMove(moveData.MovedItemsNames, targetItem.name, showMoveOrRepositionPrompt, (action) => {
                if (action == 'move') {
                    this.structureComponent.moveItems(movedItems, targetItem);
                }
            });
        }
    }

    private getErrorMessage(movedItems, targetItem) {
        let targetIsFolder = UtilityHelper.isTypeFolder(targetItem);
        let targetIsFormInstance = UtilityHelper.isTypeFormInstance(targetItem);

        let movedItemsCount = movedItems.length;
        let movedFoldersCount = movedItems.filter(x => { return UtilityHelper.isTypeFolder(x) }).length;
        if (targetIsFormInstance && movedItemsCount > 1) {
            return "You can only one Form at a time!";
        } else if (targetIsFormInstance && movedFoldersCount != 0) {
            return "You cannot drop Folders on Forms!"
        }
    }

    private cannotSortAlertTriggered(): boolean {
        if (!this.structureComponent.ColumnSortingIsOff) {
            alert(this.getColumnSortingMessage());
            return true;
        } else {
            return false;
        }
    }

    private getColumnSortingMessage(): string {
        let currentSort = this.structureComponent.ColumnSortingConfig.active;
        return 'Your view is currently sorted by the "' + currentSort + '" column. In order to reposition this Item, turn sorting off and try again.';
    }

    private doOnDragActionToStructure(event: ListItemDragActionData) {
        if (this.structureComponent.ColumnSortingIsOff) {
            this.structureComponent.DraggedItems = event;
        }
    }
}
